import {DescriptionModel} from '../shared/description.model';
import {AssetsHelper} from '../extensions/assets-helper.model';

export class QuestionModel {

  public _id: string;

  public name: string;
  public subject: string;
  public topic: string;
  public category: string;
  public subCategory: string;
  public country: string;
  public isStarterQuestion: boolean;
  public skillGroupId: string;

  /**
   * @description The answer type of the question.
   * It can be multipleChoice, input and interaction.
   */
  public answerType: string;
  public representation: string;

  public model: object;

  public isPublished = false;
  public isArchived = false;

  public decidedRank = 0;
  public rank = -1200;
  public rankCountry = new CountryBasedNumberModel();
  public numCorrectCountry = new CountryBasedNumberModel();
  public numWrongCountry = new CountryBasedNumberModel();
  public numCorrect = 0;
  public numWrong = 0;

  public majorVersion = 1;
  public minorVersion = 7;
  public revisionVersion = 9;

  public createdAt: Date;
  public updatedAt: Date;

  names = new DescriptionModel();
  descriptions = new DescriptionModel();
  audioHelp = new DescriptionModel();
  videoHelp = new DescriptionModel();

  constructor() {
    this.subject = 'math';
  }

  versionNumber(): string {

    if (this.majorVersion != null && this.minorVersion != null && this.revisionVersion != null) {

      const major = this.majorVersion.toString(10);
      const minor = this.minorVersion.toString(10);
      const revision = this.revisionVersion.toString(10);

      return major + '.' + minor + '.' + revision;

    }

    return 'Undefined';

  }

  numCorrectForCountry(country: string): number {

    if (this.numCorrectCountry) {

      return this.numCorrectCountry[country];

    } else {

      let total = 0;
      for (const key of Object.keys(this.numCorrectCountry)) {
        total += this.numCorrectCountry[key];
      }

      return total;

    }

    return 0;
  }

  numWrongForCountry(country: string): number {

    if (this.numWrongCountry) {

      return this.numWrongCountry[country];

    } else {

      let total = 0;
      for (const key of Object.keys(this.numWrongCountry)) {
        total += this.numWrongCountry[key];
      }

    }

    return 0;
  }

  numAnswers(country: string): number {

    const numCorrect = this.numCorrectForCountry(country);
    const numWrong = this.numWrongForCountry(country);

    return numCorrect + numWrong;
  }

  correctnessRatio(country: string): number {

    const total = this.numAnswers(country);
    if (total > 0) {
      return this.numCorrectForCountry(country) / total;
    }

    return 0;

  }

  correctnessRatioPercentage(country: string): number {

    return this.correctnessRatio(country) * 100;

  }

  correctnessRatioPercentageString(country: string): string {

    const ratio = this.correctnessRatioPercentage(country);

    return ratio.toFixed(2).toString() + ' %';
  }

  categoryIconURL(): string {

    return AssetsHelper.categoryIconURL(this.category);
  }

}

export class CountryBasedNumberModel {

  public ISL = 0;
  public GBR = 0;
  public FRA = 0;
  public BRA = 0;
  public SWE = 0;
  public NOR = 0;
  public LTU = 0;
  public DEU = 0;

  static generate(json: any): CountryBasedNumberModel {

    const country = new CountryBasedNumberModel();
    country.ISL = json.ISL;
    country.GBR = json.GBR;
    country.FRA = json.FRA;
    country.BRA = json.BRA;
    country.SWE = json.SWE;
    country.NOR = json.NOR;
    country.LTU = json.LTU;
    country.DEU = json.DEU;

    return country;

  }

  valueForCountry(country: string): number {

    const value = this[country];

    if (value === null || value === undefined) {

      return 0;
    }

    return value;
  }

  setValueForCountry(country: string, value: number) {

    this[country] = value;

  }

}
